import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { getActiveProjectSelector } from '../../lead-generation/projects/projects.reducer';
import { Configuration } from '../../lead-generation/shared/domain/configuration.model';
import { IState } from '../../shared/models/state';
import { Store } from '@ngrx/store';
import { LeadGenerationStylesService } from '../../lead-generation/shared/services/lead-generation-styles.service';
import { LivePreviewService } from '../../lead-generation/shared/services/live-preview.service';
import { GoToNextAppConfigurationAction, GoToNextStateAction } from '../first-steps.actions';
import { UpdateProjectStyleAction } from '../../lead-generation/projects/projects.action';
import { AmplitudeService } from '../../shared/services/amplitude.service';

@Component({
  selector: 'cc-first-steps-web-call',
  templateUrl: './first-steps-web-call.component.html',
  styleUrls: ['./first-steps-web-call.component.scss']
})
export class FirstStepsWebCallComponent implements OnInit {
  public popupSettings: FormGroup;
  public config: Configuration;

  constructor(
    private store: Store<IState>,
    private leadGenerationStylesService: LeadGenerationStylesService,
    private livePreviewService: LivePreviewService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.logAmplitude('Init');
    this.popupSettings = this.leadGenerationStylesService.createBubbleForm();

    this.store.select(getActiveProjectSelector).subscribe((config: Configuration) => {
      this.config = config;
      this.leadGenerationStylesService.updateForm(this.popupSettings, this.config, 'bubble');
    });
    this.popupSettings.valueChanges.subscribe(() => this.sendChanges());
  }

  sendChanges() {
    this.livePreviewService.sendToFrame('CHANGE_SETTINGS', this.popupSettings.value, undefined);
  }

  continueSteps() {
    this.logAmplitude('Continue');
    this.store.dispatch(
      new UpdateProjectStyleAction({
        type: 'BUBBLE',
        body: this.popupSettings.value,
        config: this.config
      })
    );
    this.store.dispatch(new GoToNextStateAction());
  }

  doItLater() {
    this.logAmplitude('Do it later');
    this.store.dispatch(new GoToNextAppConfigurationAction());
  }

  private logAmplitude(message: string) {
    this.amplitudeService.logEvent(`Panel:FirstSteps:WebCall: ${message}`);
  }
}
